<template>
  <div class="md-snackbar md-theme-default md-active md-position-bottom-right">
    <transition-group
      tag="div"
      name="vue-toast"
      :class="classesOfPosition"
    >
      <vue-toast
        v-for="(toast, index) in toasts"
        :key="toast.uid"
        :config="toast"
        :position="index"
      />
    </transition-group>
  </div>
</template>

<script>
import VueToast from './Toast'

const defaultOptions = {
  maxToasts: 6,
  position: 'botton right'
}

export default {
  components: { VueToast },
  data () {
    return {
      uid: 1,
      toasts: [],
      options: defaultOptions
    }
  },
  computed: {
    classesOfPosition () {
      return this._updateClassesOfPosition(this.options.position)
    },
    directionOfJumping () {
      return this._updateDirectionOfJumping(this.options.position)
    }
  },
  mounted () {
    let that = this
    document.addEventListener('custom-notification', function (payload) {
      that.showToast(payload.detail)
    })
  },
  methods: {
    showToast (message, options) {
      this._addToast(message, options)
      this._moveToast()
      return this
    },
    setOptions (options) {
      this.options = Object.assign(this.options, options || {})
      return this
    },
    closeAll () {
      this.toasts = []
    },
    _addToast (message, options = {}) {
      if (!message) {
        return
      }
      options.directionOfJumping = this.directionOfJumping
      const that = this
      const uid = this.uid++
      let toast = {
        uid,
        data: {
          message,
          options
        },
        onDestroy () {
          const i = that.toasts.findIndex(item => item.uid === uid)
          that.toasts.splice(i, 1)
        }
      }
      this.toasts.unshift(toast)
    },
    _moveToast (toast) {
      const maxToasts = this.options.maxToasts > 0 ? this.options.maxToasts : 9999
      this.toasts = this.toasts.reduceRight((prev, toast, i) => {
        if (i + 1 >= maxToasts) {
          return prev
        }

        return [toast].concat(prev)
      }, [])
    },
    _updateClassesOfPosition (position) {
      return position.split(' ').reduce((prev, val) => {
        prev[`__${val.toLowerCase()}`] = true

        return prev
      }, {})
    },
    _updateDirectionOfJumping (position) {
      return position.match(/bottom/i) ? '+' : '-'
    }
  }
}
</script>

<style lang="scss">
  .md-snackbar {
    z-index: 300;

    .md-snackbar-container {
      margin-top: 10px;
      margin-bottom: 10px;
      width: 466px;
      padding: 18px 24px;
    }

    .close-button {
      position: absolute;
      top: 18px;
      right: 29px;
      height: 24px;

      .md-icon {
        opacity: 1;
        color: #c2c2c2;
      }
    }

    .md-snackbar-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-size: 14px;

      .snack-title {
        font-weight: 500;
        display: block;
        display: flex;
        align-items: center;
        margin-right: 5px;
      }

      .snack-content {
        padding: 10px 0;
        width: 405px;
        display: block;
        word-wrap: break-word;
      }

      .btn-reload {
        font-weight: 500;
        padding: 0;
        color: #c2c2c2;
        margin-left: 0;

        &:hover {
          background: transparent;
        }
      }
    }
  }
</style>
